import styled from 'styled-components'

const ModalFooterActionIcons = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
`

export default ModalFooterActionIcons